/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_CrmInputs */

const cs_nav_section_crm = /** @type {(inputs: Nav_Section_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vztahy`)
};

const en_nav_section_crm = /** @type {(inputs: Nav_Section_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relations`)
};

/**
* | output |
* | --- |
* | "Relations" |
*
* @param {Nav_Section_CrmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_crm = /** @type {((inputs?: Nav_Section_CrmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_CrmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_crm(inputs)
	return cs_nav_section_crm(inputs)
});